import type { CMYKColor } from "../types/colors/CMYKColor"
import type { RGBColor } from "../types/colors/RGBColor"

/**
 * Converts RGB color to CMYK color
 * Assumes RGB values are in range 0-1
 */
export const RgbToCmyk = (rgb: RGBColor): CMYKColor => {
  const { a, b, g, r } = rgb

  // Calculate key (black)
  const k = 1 - Math.max(r, g, b)

  // Avoid division by zero
  if (k === 1) {
    return { a, c: 0, k: 1, m: 0, y: 0 }
  }

  // Calculate the CMY components
  const c = (1 - r - k) / (1 - k)
  const m = (1 - g - k) / (1 - k)
  const y = (1 - b - k) / (1 - k)

  return { a, c, k, m, y }
}
